import { render } from "./backButtonItem.vue?vue&type=template&id=31bbf9a3&scoped=true&ts=true"
import script from "./backButtonItem.vue?vue&type=script&lang=ts"
export * from "./backButtonItem.vue?vue&type=script&lang=ts"

import "./backButtonItem.vue?vue&type=style&index=0&id=31bbf9a3&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31bbf9a3"]])

export default __exports__